import { environment } from './../../environments/environment';
import { Component, OnInit, AfterViewInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';

@Component({
    selector: 'app-services',
    templateUrl: 'services.component.html'
})

export class ServicesComponent implements OnInit, AfterViewInit {

    news: any[] = [];
    topDepartment: Observable<any>;
    topCatalogType: Observable<any>;
    links: any;
    services: any;
    baseHref = '';

    constructor(private http: HttpClient, private router: Router) {
      this.baseHref = environment.baseHref.substr(0, environment.baseHref.length - 1);
    }

    ngOnInit() {
        this.http.get("api/posts/list/published/top3").subscribe((n: any[]) => {
            this.news = n;  
            setTimeout(()=>{                           // <<<---using ()=> syntax
                this. openNews();
            }, 100);
        });

        this.links = this.http.get('api/posts/link/org').map((r: any[]) => {
            return this.buildRows(r);
        });
        this.services = this.http.get('api/posts/link/services').map((r: any[]) => {
           
            return this.buildRows(r); 
        });

        this.topDepartment = this.http.get('api/common/getTopDepartment?total=6&searchStr=&sort=');
        this.topCatalogType = this.http.get('api/common/getTopCatalogType?total=6&searchStr=&sort=');
        
        
    }

    buildRows(r) {
        let build = [];
        let filtered = r.slice(0, 5);

        let row = [];
        for (let i = 0; i < filtered.length; i++) {
            if (i % 3 === 0 && i !== 0) {
                build.push(row);
                row = [];
                row.push(filtered[i]);
            } else {
                row.push(filtered[i]);
            }
        }
        if (row.length > 0)
            build.push(row);

        
        return build;
    }

    ngAfterViewInit(): void {
        
    }

    getThumbnail(post) {
        let img = (post.meta as any[]).find(i => i.key == "attach_fileinfo_id");
        return img ? `files/posts/${img.id}.png` : undefined;
    }

    openNews() {
        if (!this.news || this.news.length == 0)
            return;

        jQuery('.owl-carousel3').owlCarousel({
            margin: 60,
            pagination: false,
            navigation: true,
            items: 3,
            addClassActive: true,
            responsive: {
                0: {
                    items: 1
                },
                479: {
                    items: 1
                },
                768: {
                    items: 2
                },
                979: {
                    items: 3
                },
                1199: {
                    items: 3
                }
            }
        });
        jQuery('#news').slideDown('slow');
        jQuery('.more-btn').slideDown('slow');
        jQuery('.open-news-btn').hide('200');
        var owl = jQuery('.owl-carousel3').data('owlCarousel');
        owl.onResize();
    }

    goToUrl(url){
        this.router.navigateByUrl(url);
    }
    
}



// WEBPACK FOOTER //
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/app/home/services.component.ts